import { useMutation } from "@tanstack/react-query";

import { authApi } from "@shared/api";

type TOTPParams = {
  email: string;
  totp: string;
};

export const useSignInVerifyTOTP = () => {
  const { error, mutateAsync, isPending } = useMutation({
    mutationFn: (payload: TOTPParams) =>
      authApi.postApiV1AuthSignInVerify(
        {
          requestSource: "WEB",
          verifySignInRequest: {
            email: payload.email,
          },
          xTOTP: payload.totp,
        },
        { withCredentials: true },
      ),
  });

  return { error, signInVerify: mutateAsync, isPending };
};
